jQuery(document).ready(function ($) {
    let contact_form = document.getElementById('contact-form');
    let post_code = contact_form.querySelector('#postcode');
    let phone = contact_form.querySelector('#phone');
    let email = contact_form.querySelector('#email');

    let postCodeMaskOptions = {
        mask: '000 00'
    };
    let post_code_mask = IMask(post_code, postCodeMaskOptions);

    let cleave = new Cleave('.cleave-phone', {
        phone: true, phoneRegionCode: 'CZ'
    });

    let alert_msg = $('#contact-form-alert-message');
    alert_msg.hide();

    function showAlertMessage(message, isSuccess = true) {
        alert_msg.find('.alert-message').text(message);

        if (isSuccess) {
            alert_msg.removeClass('alert-danger').addClass('alert-success');
        } else {
            alert_msg.removeClass('alert-success').addClass('alert-danger');
        }

        alert_msg.show();
    }

    function validatePostCode(postcode) {
        return /^\d{3} \d{2}$/.test(postcode);
    }

    function validateEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function validateCzechPhone(phone) {
        return /^(\+420|00420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/.test(phone);
    }

    $('#contact-form').on('submit', function (event) {
        event.preventDefault();
        let form = $(this);

        alert_msg.hide();
        alert_msg.find('.alert-message').text('');

        let name = this.name.value;
        let email = this.email.value;
        let phone = this.phone.value;
        let postcode = this.postcode.value;
        let message = this.message.value;
        let select_option = this.source.value;
        let recaptcha_response = this.recaptcha_response.value;

        let errors = [];

        if (!validateEmail(email)) {
            errors.push("Neplatná e-mailová adresa.");
        }

        if (!validateCzechPhone(phone)) {
            errors.push("Neplatné telefonní číslo.");
        }

        if (!validatePostCode(postcode)) {
            errors.push("Neplatné PSČ.");
        }

        if (errors.length > 0) {
            showAlertMessage(errors[0], false);
            return;
        }

        let submitBtn = form.find('button[type="submit"]');
        let btnOriginalHtml = submitBtn.html();
        submitBtn.prop('disabled', true).html('<i class="fa-light fa-spinner-third fa-spin"></i> Odesílám...');

        // AJAX call
        $.ajax({
            type: 'POST', url: MyAjax.ajaxurl, data: {
                action: 'handle_contact_form_submission',
                name: name,
                email: email,
                phone: phone,
                postcode: postcode,
                message: message,
                source: select_option,
                nonce: MyAjax.nonce,
                recaptcha_response: recaptcha_response
            }, success: function (response) {
                if (response.success) {
                    showAlertMessage(response.data, true);
                    form.hide();
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'form_submit',
                        form:  'contact-form',
                        customer: {
                            name: name,
                            email: email,
                            phone: phone,
                            postcode: postcode,
                            message: message,
                            source: select_option
                        }
                    });
                } else {
                    showAlertMessage(response.data, false);
                }
            }, error: function (xhr, status, error) {
                showAlertMessage(xhr.responseJSON.data, false);
                submitBtn.prop('disabled', false).html(btnOriginalHtml);
            }
        });
    });
});